import { z } from 'zod';

// #1244 Phase B: Aufgaben-Automatik-Vorlage an einer Rechtsgeschäftsart-Maßnahme.
export const taskAutomationSchema = z.object({
  idTaskAutomation: z.number().default(-1),
  // Genau eines von beiden ist gesetzt: Vorlage (Rechtsgeschäftsart) ODER
  // konkrete Maßnahme (Vorgang, aus der Vorlage kopiert).
  idLegalRequirementTemplate: z.number().nullable().default(null),
  idLegalRequirement: z.number().nullable().default(null),
  idLegalRequirementState: z.number().default(-1),
  Title: z.string().default(''),
  Body: z
    .string()
    .nullable()
    .transform(v => v ?? '')
    .default(''),
  ProcessingTime: z.number().default(14),
  idTaskType: z.number().nullable().default(1),
  idTaskPriority: z.number().nullable().default(3),
  User_idUser: z.number().nullable().default(null),
  UserGroup_idUserGroup: z.number().nullable().default(null),
  // Platzhalter: der dem Vorgang zugeordnete MA/Gruppe bekommt die Aufgabe (Standard).
  AssignToTransactionResponsible: z
    .union([z.boolean(), z.number().transform(v => Boolean(v))])
    .transform(v => Boolean(v))
    .default(true),
  activeTaskAutomation: z
    .union([z.boolean(), z.number().transform(v => Boolean(v))])
    .transform(v => Boolean(v))
    .default(true),
  // Aus Relationen
  LegalRequirementState: z.string().optional(),
  TaskType: z.string().optional(),
  TaskPriority: z.string().optional(),
});

export type ITaskAutomation = z.infer<typeof taskAutomationSchema>;
